module.exports = __webpack_public_path__ + "img/photon-capacitor-full.185fc236.png";